import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { CIError } from 'common/error/error_util';
import { usePageStatus } from 'common/hooks/use-page-status';
import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

import CreatePasswordForm from '../create_password_form';

interface CreatePasswordViewProps {
    error?: CIError;
}

export const CreatePasswordView = ({ error }: CreatePasswordViewProps): ReactElement => {
    const { t } = useTranslation('auth');
    const pageStatus = usePageStatus();
    const [formSubmitted, setFormSubmitted] = useState(false);

    function handleFormSubmit(): void {
        pageStatus.dismiss();
        setFormSubmitted(true);
    }

    useEffect(() => {
        if (error) {
            pageStatus.error(t(error.translationKey));
            setFormSubmitted(false);
        }
    }, [error]);

    return (
        <>
            <h1 className="header" id="create_password_header">
                {t('password_form.create_pass_header')}
            </h1>
            <CreatePasswordForm onSubmit={handleFormSubmit} submitting={formSubmitted}>
                {(disableButton, submitButtonClass): ReactElement => (
                    <CISecondaryButton
                        className={submitButtonClass}
                        type="submit"
                        id="activationCodeButton"
                        disabled={disableButton}
                        isLoading={formSubmitted}
                        fullWidth
                    >
                        {t('password_form.create_button')}
                    </CISecondaryButton>
                )}
            </CreatePasswordForm>
        </>
    );
};
